export default __webpack_public_path__ + "static/media/battery.46edff16.svg";